import { render, staticRenderFns } from "./HemisphereLight.vue?vue&type=template&id=cc79be6e&scoped=true&"
import script from "./HemisphereLight.vue?vue&type=script&lang=js&"
export * from "./HemisphereLight.vue?vue&type=script&lang=js&"
import style0 from "./HemisphereLight.vue?vue&type=style&index=0&id=cc79be6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc79be6e",
  null
  
)

export default component.exports